<template>
    <div>
        <el-upload
					v-loading="loading"
					ref="upload"
					class="avatar-uploader"
					action=""
					accept="image/png,image/jpg,image/jpeg,image/gif"
					:show-file-list="false"
					:before-upload="beforeUpload"
					:http-request="uploadFile"
        >
					<img v-if="imageUrl" :src="imageUrl" class="avatarImg">
					<div v-else class="uploader">
						<i  class="el-icon-plus avatar-uploader-icon">
							<div v-if="name">{{name}}</div>
						</i>
					</div>
        </el-upload>
    </div>
</template>

<script>
export default {
    name: "UploadImg",
    props: {
        imageUrl: {
					type: String,
					default: '',
        },
				name: {
					type: String,
          default: '',
				},
				domKeys: {
					type: String,
          default: '',
				}
    },
    data () {
        return {
          loading: false
        }
    },
    methods: {
			beforeUpload (file) {
					if(this.domKeys){
						this.$emit('setDomKeys', this.domKeys)
					}
					const isImg = /^image\/(jpeg|png|jpg|gif)$/.test(file.type)
					const isLt5M = file.size / 1024 / 1024 < 5;
					if (!isImg) {
							this.$message.error('上传图片格式为jpg/jpeg/gif/png');
					}
					if (!isLt5M) {
							this.$message.error('上传图片大小不能超过 5MB');
					}
					return isImg && isLt5M;
			},
			uploadFile (data) {
					this.loading = true
					const formData = new FormData()
					formData.append('file', data.file)
					formData.append('picType', 1)
					return this.$api.DriverModel.getPicUpdate(formData).then(res => {
							const imageUrl = res.data.imgUrl || ''
							this.$emit('setImgUrl', imageUrl)
							this.loading = false
					}).catch(()=>{
							this.loading = false
					});
			},
			submitUpload(){
				this.$refs.upload.$refs['upload-inner'].handleClick();
			}
    }
}
</script>

<style scoped lang="scss">
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
	width: 120px;
	height: 120px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.uploader{
  display: flex;
  width: 120px;
  height: 120px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  div{
    margin-top: 10px;
    font-size: 12px;
  }
}
::v-deep .avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.avatarImg{
	width: 120px;
  height: 120px;
  // display: inline-block;
	// text-align: center;
}
</style>
